import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2 border bg-white rounded w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Quais produtos serão descarregados?", -1)
const _hoisted_3 = {
  key: 0,
  class: "w-full flex flex-col gap-2 mt-2"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "w-full flex flex-wrap" }
const _hoisted_9 = { class: "mx-auto" }

import { novoAgendamentoTransporteProduto } from "@/data/agendamento_transporte_produto";
import { AgendamentoTransporteProduto } from "@/types/agendamento_transporte_produto";
import { computed, inject, ref } from "vue";
import DialogModal from "../Modal/DialogModal.vue";
import ListHeader from "../ListHeader.vue";
import FormValidated from "../FormValidated.vue";
import InputText from "../inputs/InputText.vue";
import InputNumber from "../inputs/InputNumber.vue";
import InputFile from "../inputs/InputFile.vue";
import { FormValidatedUpdateKey, FormValidatedValuesKey } from "@/types/inject";
import helpers from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProdutosASeremDescarregados',
  setup(__props) {

const modal = ref<AgendamentoTransporteProduto | null>(null);

const abreModal = ref(false);

const adicionarProduto = () => {
  modal.value = novoAgendamentoTransporteProduto();
  abreModal.value = true;
};

const values = inject(FormValidatedValuesKey, {});

const onUpdate = inject(FormValidatedUpdateKey);

const produtosAtuais = computed<AgendamentoTransporteProduto[]>(
  () => values["produtos"] ?? ([] as any)
);

const salvarProduto = (values: AgendamentoTransporteProduto) => {
  typeof onUpdate === "function" &&
    onUpdate({
      ["produtos"]: [
        ...produtosAtuais.value,
        {
          ...values,
        },
      ] as any,
    });

  abreModal.value = false;
  modal.value = null;
};

const apagarProdutoPeloIndice = (index: number) => {
  typeof onUpdate === "function" &&
    onUpdate({
      ["produtos"]: produtosAtuais.value.filter((_, i) => i != index) as any,
    });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(produtosAtuais).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(produtosAtuais), (produto, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${produto.nome}${produto.data_validade}`,
              class: "p-2 border rounded bg-gray-100 relative"
            }, [
              _createElementVNode("button", {
                onClick: ($event: any) => (apagarProdutoPeloIndice(index)),
                type: "button",
                title: "Apagar produto?",
                class: "text-red-500 hover:text-red-600 absolute right-2 top-1"
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "trash" })
              ], 8, _hoisted_4),
              _createElementVNode("b", null, _toDisplayString(produto.nome), 1),
              _createTextVNode(),
              _hoisted_5,
              _createElementVNode("small", null, "Validade: " + _toDisplayString(_unref(helpers).formatData(produto.data_validade)) + " - Lote: " + _toDisplayString(produto.lote), 1),
              _hoisted_6,
              _createElementVNode("small", null, "Quantidade: " + _toDisplayString(_unref(helpers).formatValor(produto.quantidade)), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_t_button, { onClick: adicionarProduto }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: "plus" }),
          _createTextVNode(" Adicionar produto ")
        ]),
        _: 1
      })
    ]),
    _createVNode(DialogModal, {
      show: abreModal.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (abreModal.value = false))
    }, {
      title: _withCtx(() => [
        _createVNode(ListHeader, { label: "Adicionar Produto" }, {
          default: _withCtx(() => [
            _createVNode(_component_t_button, {
              color: "gray",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (abreModal.value = false)),
              class: "mt-0"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Voltar")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        (modal.value)
          ? (_openBlock(), _createBlock(FormValidated, {
              key: 0,
              "initial-values": modal.value,
              "hide-buttons": true,
              onSave: salvarProduto,
              validation: {
            nome: 'required',
            data_validade: 'required',
            lote: 'required',
            laudo: 'required',
            quantidade: 'min:0.01',
          }
            }, {
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(InputText, {
                    label: "Nome do produto",
                    maxlength: "240",
                    name: "nome",
                    tclass: "md:w-1/2",
                    placeholder: "Nome do produto"
                  }),
                  _createVNode(InputText, {
                    label: "Data de validade",
                    name: "data_validade",
                    tclass: "md:w-1/2",
                    type: "date"
                  }),
                  _createVNode(InputText, {
                    label: "Lote",
                    name: "lote",
                    tclass: "md:w-1/2",
                    placeholder: "Lote",
                    maxlength: "240"
                  }),
                  _createVNode(InputNumber, {
                    label: "Quantidade conforme nota fiscal",
                    name: "quantidade",
                    tclass: "md:w-1/2",
                    placeholder: "Quantidade conforme nota fiscal"
                  }),
                  _createVNode(InputFile, {
                    label: "Laudo em PDF",
                    name: "laudo",
                    tclass: "md:w-full",
                    accept: "application/pdf"
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_t_button, {
                      class: "ml-3",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "save",
                          class: "mr-1"
                        }),
                        _createTextVNode(" Adicionar Produto ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }, 8, ["initial-values", "validation"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})